"use strict";

require("core-js/modules/es6.function.name");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.is-array");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _isPropValid = _interopRequireDefault(require("@emotion/is-prop-valid"));

var _index = require("../index");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/**
 * This file contains an runtime version of `styled` component. Responsibilities of the component are:
 * - returns ReactElement based on HTML tag used with `styled` or custom React Component
 * - injects classNames for the returned component
 * - injects CSS variables used to define dynamic styles based on props
 */
// eslint-disable-line import/no-extraneous-dependencies
// Workaround for rest operator


var restOp = function restOp(obj, keysToExclude) {
  return Object.keys(obj).filter(function (prop) {
    return !keysToExclude.includes(prop);
  }).reduce(function (acc, curr) {
    return Object.assign(acc, _defineProperty({}, curr, obj[curr]));
  }, {});
}; // rest operator workaround


var warnIfInvalid = function warnIfInvalid(value, componentName) {
  if (process.env.NODE_ENV !== 'production') {
    if (typeof value === 'string' || // eslint-disable-next-line no-self-compare
    typeof value === 'number' && isFinite(value)) {
      return;
    }

    var stringified = typeof value === 'object' ? JSON.stringify(value) : String(value); // eslint-disable-next-line no-console

    console.warn("An interpolation evaluated to '" + stringified + "' in the component '" + componentName + "', which is probably a mistake. You should explicitly cast or transform the value to a string.");
  }
}; // If styled wraps custom component, that component should have className property


function styled(tag) {
  return function (options) {
    if (process.env.NODE_ENV !== 'production') {
      if (Array.isArray(options)) {
        // We received a strings array since it's used as a tag
        throw new Error('Using the "styled" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly. See https://github.com/callstack/linaria#setup');
      }
    }

    var render = function render(props, ref) {
      var _props$as = props.as,
          component = _props$as === void 0 ? tag : _props$as,
          className = props["class"];
      var rest = restOp(props, ['as', 'class']);
      var filteredProps; // Check if it's an HTML tag and not a custom element

      if (typeof component === 'string' && component.indexOf('-') === -1) {
        filteredProps = {}; // eslint-disable-next-line guard-for-in

        for (var key in rest) {
          if (key === 'as' || (0, _isPropValid["default"])(key)) {
            // Don't pass through invalid attributes to HTML elements
            filteredProps[key] = rest[key];
          }
        }
      } else {
        filteredProps = rest;
      }

      filteredProps.ref = ref;
      filteredProps.className = (0, _index.cx)(filteredProps.className || className, options["class"]);
      var vars = options.vars;

      if (vars) {
        var style = {}; // eslint-disable-next-line guard-for-in

        for (var name in vars) {
          var _vars$name = _slicedToArray(vars[name], 2),
              result = _vars$name[0],
              _vars$name$ = _vars$name[1],
              unit = _vars$name$ === void 0 ? '' : _vars$name$;

          var value = typeof result === 'function' ? result(props) : result;
          warnIfInvalid(value, options.name);
          style["--" + name] = "" + value + unit;
        }

        filteredProps.style = Object.assign(style, filteredProps.style);
      }

      if (tag.__linaria && tag !== component) {
        // If the underlying tag is a styled component, forward the `as` prop
        // Otherwise the styles from the underlying component will be ignored
        filteredProps.as = component;
        return React.createElement(tag, filteredProps);
      }

      return React.createElement(component, filteredProps);
    };

    var Result = React.forwardRef ? React.forwardRef(render) : // React.forwardRef won't available on older React versions and in Preact
    // Fallback to a innerRef prop in that case
    function (props) {
      var rest = restOp(props, ['innerRef']);
      return render(rest, props.innerRef);
    };
    Result.displayName = options.name; // These properties will be read by the babel plugin for interpolation

    Result.__linaria = {
      className: options["class"],
      "extends": tag
    };
    return Result;
  };
}

var _default = process.env.NODE_ENV !== 'production' ? new Proxy(styled, {
  get: function get(o, prop) {
    return o(prop);
  }
}) : styled;

exports["default"] = _default;